module.exports = __webpack_public_path__ + "static/img/04996744.3abe6a73.png";